/**
 *
 * Mixin para exportação de listagens.
 *
 * @param {String} endpoint
 * @param {String} params
 *
 *
*/

// request
import { get } from '@/helpers/requests';

export default {
    data: () => ({
        loading: false,
        errorExport: false,
        emailSent: false
    }),
    methods: {
        async exportsFiles ( endpoint, params = {}, filename ) {
            if ( this.loading )
                return;

            // executa loading
            this.loading = true;
            const anchor = this.$el.querySelector( '.download' ); // obtém o elemento da anchor

            await get( endpoint, { ...params }, { responseType: 'blob' })
                .then( response => {
                    // Se a resposta for json mostra a mensagem que o email foi enviado
                    if ( response.headers['content-type'] === 'application/json' ) {
                        this.errorExport = false;
                        this.emailSent = true;
                        setTimeout( () => {
                            this.emailSent = false;
                        }, 3000 );
                    } else {
                        // Se for ficheiro faz o download
                        this.emailSent = false;
                        const blob = new Blob( [ response.data ], { type: response.headers['content-type'] });
                        const urlFile = window.URL.createObjectURL( blob ); // cria um url temporário para download do ficheiro.
                        anchor.href = urlFile;

                        const header = response.headers['content-disposition']; // obtém o header onde está o nome do ficheiro.
                        const nameFile = filename || ( header ) ? header.split( 'filename=' )[1] : 'associados.xlsx'; // obtém o nome do ficheiro.

                        anchor.download = nameFile;
                        anchor.click();
                    }
                }).catch( () => {
                    this.errorExport = true;
                    setTimeout( () => {
                        this.errorExport = false;
                    }, 3000 );
                });
            this.loading = false;
        }
    }
};